"use strict";

exports.__esModule = true;
exports.default = void 0;

/* eslint-disable no-nested-ternary */
var getTableProps = function getTableProps(props, _ref) {
  var instance = _ref.instance;
  return [props, {
    style: {
      minWidth: instance.totalColumnsWidth + "px"
    }
  }];
};

var getRowStyles = function getRowStyles(props) {
  return [props, {
    style: {
      display: 'flex' // flex: '1 0 auto',
      // minWidth: `${instance.totalColumnsMinWidth}px`

    }
  }];
};

var getHeaderProps = function getHeaderProps(props, _ref2) {
  var column = _ref2.column;
  return [props, {
    style: column.minWidth ? {
      flex: "1 0 " + column.minWidth + "px"
    } : column.maxWidth && column.maxWidth < 1000 ? {
      flex: "0 1 " + column.maxWidth + "px"
    } : {
      flex: "0 0 " + column.width + "px"
    }
  }];
};

var getCellProps = function getCellProps(props, _ref3) {
  var cell = _ref3.cell;
  return [props, {
    style: cell.column.minWidth ? {
      flex: "1 0 " + cell.column.minWidth + "px"
    } : cell.column.maxWidth && cell.column.maxWidth < 1000 ? {
      flex: "0 1 " + cell.column.maxWidth + "px"
    } : {
      flex: "0 0 " + cell.column.width + "px"
    }
  }];
};

var useUKFlexLayout = function useUKFlexLayout(hooks) {
  hooks.getTableProps.push(getTableProps);
  hooks.getRowProps.push(getRowStyles);
  hooks.getHeaderGroupProps.push(getRowStyles);
  hooks.getHeaderProps.push(getHeaderProps);
  hooks.getCellProps.push(getCellProps);
};

useUKFlexLayout.pluginName = 'useUKFlexLayout';
var _default = useUKFlexLayout;
exports.default = _default;